import { useContext } from 'react';
import { FlagContext } from '../FlagContext';
import { isFlagEnabled, isAnyFlagEnabled } from '../helpers';
export function useFlag(flag) {
    const flags = useContext(FlagContext);
    return isFlagEnabled(flags, flag);
}
export function useAnyFlag(flagSet) {
    const flags = useContext(FlagContext);
    return isAnyFlagEnabled(flags, flagSet);
}
